var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8213 26.6667H25.4749C27.008 26.6667 28.2274 25.9681 29.3224 24.9915C32.1038 22.5101 25.5653 20 23.3332 20M20.6665 6.75836C20.9693 6.69831 21.2837 6.66667 21.6062 6.66667C24.0328 6.66667 25.9998 8.45754 25.9998 10.6667C25.9998 12.8758 24.0328 14.6667 21.6062 14.6667C21.2837 14.6667 20.9693 14.6351 20.6665 14.5749",
    stroke: "#DB3437",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97508 21.4816C4.40312 22.324 0.281518 24.0441 2.79184 26.1965C4.01812 27.248 5.38388 28 7.10096 28H16.8991C18.6161 28 19.9819 27.248 21.2081 26.1965C23.7185 24.0441 19.5969 22.324 18.0249 21.4816C14.3387 19.5061 9.66132 19.5061 5.97508 21.4816Z",
    stroke: "#DB3437",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 10C17.3332 12.9455 14.9453 15.3333 11.9998 15.3333C9.05432 15.3333 6.6665 12.9455 6.6665 10C6.6665 7.05449 9.05432 4.66667 11.9998 4.66667C14.9453 4.66667 17.3332 7.05449 17.3332 10Z",
    stroke: "#DB3437",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMultiple);
export default __webpack_public_path__ + "static/media/user-multiple.1a3bbb20bcc0a5ab60874ad51b42fdae.svg";
export { ForwardRef as ReactComponent };